<template>
  <div>
    <assessment-helper></assessment-helper>
    <section class="activity-stage">
      <blinking-cursor-text
        v-for="(step, index) in currentRound.steps"
        :key="`step${index}`"
        :text-size="currentRound.textSize"
        :text="step.answer"
        :text-step="index"
      ></blinking-cursor-text>
    </section>

    <slot name="keyboard"></slot>
  </div>
</template>

<script>
import { TweenMax, TimelineLite } from 'gsap';

import ActivityManager from 'mixins/ActivityManager';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';

import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import AssessmentHelper from 'components/utils/AssessmentHelper.vue';

export default {
  mixins: [ActivityManager, AssetLoader, ErrorLogger, TypingActivityHelper],

  components: {
    AssessmentHelper,
    BlinkingCursorText
  },

  data() {
    return {
      activityName: 'Paragraph'
    };
  },

  methods: {
    getActivityState() {
      const { rounds } = this.activityData;

      return {
        rounds,
        instructions: {
          written: 'Begin typing for a speed and accuracy check.',
          voice: `${
            this.voiceInstructionsPrefix
          }/spotcheckparagraphsa-${this.getRandomVoice()}.mp3`,
          delay: 3
        }
      };
    },

    async loadActivity() {
      const roundSetup = this.getActivityState();
      this.createRounds(roundSetup);
    },

    getKeyboardConfig() {
      const { keyboardType, roofs } = this.activityData.keyboard;
      return {
        keyboardType,
        roofs
      };
    },

    startActivity() {
      this.setRound();
      this.errorLoggerStart();
    },

    setRound() {
      this.setCurrentStep();
      this.setupNewRound();
      this.enableKeyboard();
      this.$nextTick(() => {
        TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
      });
    },

    handleCorrectKey() {
      this.sndType();
      this.incrementTypingIndex();

      if (this.isEndOfCurrentSentence) {
        this.setCurrentStep();
      }

      if (this.isEndOfRound) {
        this.handleRoundEnd();
      }
    },

    handleRoundEnd() {
      const t = new TimelineLite();
      this.sndBell();

      t.delay(0.8).call(() => {
        if (this.isLastRound) {
          this.handleActivityEnd();
        } else {
          t.delay(1)
            .to('.activity-stage', 0.8, { opacity: 0 })
            .call(this.setRound);
        }
      });
    },

    handleActivityEnd() {
      this.hideKeyboard();
      TweenMax.delayedCall(1, this.completeActivity);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/fade.scss';

.activity-stage {
  margin-top: 45px;
  position: relative;
  height: 60%;
  font-size: 1.5em;
  display: flex;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;

  p {
    margin: auto;
    font-size: 1.1em;
    width: 65%;
    text-align: justify;
  }
}
</style>
